var Const = /** @class */ (function () {
    function Const() {
    }
    Const.RUN_GET_BANK_DETAILS = '/RUN_GET_BANK_DETAILS';
    Const.SET_BANK_DETAILS = '/SET_BANK_DETAILS';
    Const.GET_BANK_DETAILS = '/GET_BANK_DETAILS';
    Const.RUN_ADD_BANK_DETAILS = '/RUN_ADD_BANK_DETAILS';
    Const.RUN_FIAT_WITHDRAWAL_REQUEST_OTP = '/RUN_FIAT_WITHDRAWAL_REQUEST_OTP';
    Const.RUN_FIAT_WITHDRAWAL_REQUEST_RESEND_OTP = '/RUN_FIAT_WITHDRAWAL_REQUEST_RESEND_OTP';
    Const.RUN_FIAT_WITHDRAWAL_REQUEST = '/RUN_FIAT_WITHDRAWAL_REQUEST';
    Const.RUN_Edit_BANK_DETAILS = '/RUN_Edit_BANK_DETAILS';
    Const.RUN_DELETE_PAYMENT_METHOD = '/RUN_DELETE_PAYMENT_METHOD';
    Const.RUN_GET_WITHDRAWAL_METHODS = '/RUN_GET_WITHDRAWAL_METHODS';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE = '/SET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE = '/GET_WITHDRAWAL_METHOD_RESPONSE';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/SET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/GET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    //deposit
    Const.RUN_GENERATE_WALLET_ADDRESS = '/RUN_GENERATE_WALLET_ADDRESS';
    Const.GET_GENERATE_WALLET_ADDRESS = '/GET_GENERATE_WALLET_ADDRESS';
    Const.SET_GENERATE_WALLET_ADDRESS = '/SET_GENERATE_WALLET_ADDRESS';
    Const.RUN_TRANS_LIMIT_CURRENCY = '/RUN_TRANS_LIMIT_CURRENCY';
    //payment method
    /*public static RUN_GET_PAYMENT_METHODS:string = '/RUN_GET_PAYMENT_METHODS'
    public static GET_PAYMENT_METHODS:string = '/GET_PAYMENT_METHODS'
    public static SET_PAYMENT_METHODS:string = '/SET_PAYMENT_METHODS'*/
    Const.RUN_DEMO_DEPOSIT = '/RUN_DEMO_DEPOSIT';
    Const.RUN_GET_USER_CAN_DEPOSIT = '/RUN_GET_USER_CAN_DEPOSIT';
    Const.SET_DEPOSIT_LIMIT = '/SET_DEPOSIT_LIMIT';
    Const.GET_DEPOSIT_LIMIT = '/GET_DEPOSIT_LIMIT';
    Const.RUN_CREDIT_CARD_DEPOSIT = '/RUN_CREDIT_CARD_DEPOSIT';
    Const.RUN_WITHDRAWAL_REQUEST_OTP = '/RUN_WITHDRAWAL_REQUEST_OTP';
    Const.RUN_WITHDRAWAL_CHECK_OTP = '/RUN_WITHDRAWAL_CHECK_OTP';
    Const.RUN_RESEND_EMAIL_LINK = '/RUN_RESEND_EMAIL_LINK';
    Const.RUN_GET_WITHDRAWAL_DESC = '/RUN_GET_WITHDRAWAL_DESC';
    Const.RUN_GET_DEPOSIT_LIST = '/RUN_GET_DEPOSIT_LIST';
    Const.GET_DEPOSIT_LIST = '/GET_DEPOSIT_LIST';
    Const.SET_DEPOSIT_LIST = '/SET_DEPOSIT_LIST';
    Const.GET_DEPOSIT_Status = '/GET_DEPOSIT_Status';
    Const.RUN_GET_WITHDRAWAL_LIST = '/RUN_GET_WITHDRAWAL_LIST';
    Const.GET_WITHDRAWAL_LIST = '/GET_WITHDRAWAL_LIST';
    Const.SET_WITHDRAWAL_LIST = '/SET_WITHDRAWAL_LIST';
    Const.RUN_GET_WITH_DEPO_CUR_LIST = '/RUN_GET_WITH_DEPO_CUR_LIST';
    Const.GET_WITH_DEPO_CUR_LIST = '/GET_WITH_DEPO_CUR_LIST';
    Const.SET_WITH_DEPO_CUR_LIST = '/SET_WITH_DEPO_CUR_LIST';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/depositWithdrawal/provider/lib/const.cls.ts
// module id = aOVz
// module chunks = 1